
























































































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "../../plugins/http";

@Component
export default class Pic extends Vue {
  isTest: boolean = false;
  fileList: any[] = [];
  types: any[] = [];
  picName: string = "";
  type: any = null;
  imgs: any[] = [];
  imgTitle: any[] = [];
  imgRow: any[] = [];
  imgLength: number = 0;
  changeIndex: number = 0;
  timer: any = null;
  alphe: string[] = ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J"];
  isWrong: boolean = false;
  picResult: any[] = [];
  isBindStatus: boolean = false;
  isUploading: boolean = false;
  templateRow: any[] = []; // 虚拟排序row数组

  @Watch("type")
  typeWatch() {
    if (this.type.length > 0) {
      let id = this.type[1];
      let label = this.type[0];

      let childrenList = this.types.filter((item: any) => {
        return item.label === label;
      });
      this.imgLength = childrenList[0].children.filter(
        (i) => i.id === id
      )[0].picCount;
      this.imgTitle = childrenList[0].children
        .filter((i) => i.id === id)[0]
        .titles.split(",");
      this.imgs = [];
      this.imgRow = [];
    } else {
      this.imgLength = 0;
      this.imgTitle = [];
    }
    // if (this.type === null) {
    //   this.imgLength = 0;
    //   this.imgTitle = [];
    // } else {
    //   this.imgLength = this.types.filter((i) => i.id === this.type)[0].picCount;
    //   this.imgTitle = this.types.filter((i) => i.id === this.type)[0].titles;
    //   this.imgs = [];
    //   this.imgRow = [];
    // }
    this.templateRow = [];
    this.fileList = [];
    this.picResult = [];
    this.picName = "";
  }
  created() {
    if (this.$route.query.env === "test") {
      this.isTest = true;
    }
    this.getAllType();
  }

  getAllType() {
    Axios.getSecret(`/api/common/categories`).then(
      ({ data: { status, data, msg } }) => {
        if (status === 200) {
          data.map((item: any) => {
            item.leaf = false;
            item.value = item.label ? item.label : "";
            item.children &&
              item.children.map((i: any) => {
                i.leaf = true;
                i.value = i.id ? i.id : "";
                i.label = i.name;
                delete i.children;
              });
          });

          // if (this.isTest) {
          //   //隐藏不带星号的项
          //   data.map((item: any) => {
          //     if (item.children) {
          //       item.children = item.children.filter((i: any) => {
          //         return !/^\★.*$/.test(i.label);
          //       });
          //     }
          //   });
          // } else {
          //   //隐藏不带星号的项
          //   data.map((item: any) => {
          //     if (item.children) {
          //       item.children = item.children.filter((i: any) => {
          //         return /^\★.*$/.test(i.label);
          //       });
          //     }
          //   });
          // }
          //隐藏子级菜单为空的项
          data = data.filter((item: any) => {
            return item.children.length > 0;
          });
          this.types = data;
        } else {
          this.$message(msg);
        }
      }
    );
  }

  clickBindUpload() {
    this.isBindStatus = true;
  }
  clearBindStatus() {
    this.changeIndex = 0;
    this.fileList = [];
    this.imgRow = [];
    this.imgs = [];
    this.picResult = [];
    this.templateRow = [];
  }

  handleChange(file, fileList, index) {
    let reads = new FileReader();
    let _this = this;
    this.picName = '';
    reads.readAsDataURL(file.raw);
    reads.onload = function (e) {
      if (index === true) {
        if (_this.isBindStatus) {
          _this.clearBindStatus();
          _this.isBindStatus = false;
        }
        _this.setTimeoutPic(this.result, file.raw);
      } else {
        _this.$set(_this.imgs, index, this.result);
        _this.imgRow[index] = file.raw;
        _this.picName = _this.imgRow[0].name.split(".")[0];
        
      }
      _this.fileList = fileList.slice(-1);
      
    };
    

  }

  setTimeoutPic(res, raw) {
    this.picResult[this.changeIndex] = res;
    // this.imgRow[this.changeIndex] = raw;
    this.templateRow[this.changeIndex] = raw;
    this.changeIndex += 1;
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      const alphes = this.alphe.slice(0, this.changeIndex);
      const correctImgList = [];
      this.fileList = [];
      const index = this.changeIndex;
      console.log(this.templateRow);
      console.log(this.imgTitle);
      if (index !== this.imgLength) {
        if(this.templateRow.length === 0){
          this.$alert('未获取到图片');
          return;
        }
        const currentImgName = this.templateRow.map((file:any)=>{
          return file.name;
        })
        this.clearBindStatus();
        this.$alert(`<p>数量不正确。</p><p>当前上传的图片是${currentImgName.join(',')}。</p><p>需要上传的是${this.imgTitle.join(',')}。</p><p>请检查上传图片是否正确。</p>`, '提示', {
          dangerouslyUseHTMLString: true
        });
        return;
      }

      for (let i = 0; i < index; i++) {
        const matchs = this.templateRow[i].name.match(/(?!.*?-)[A-Z](?=\..*$)/);
        if (matchs && alphes.indexOf(matchs[0]) !== -1) {
          const correctIndex = alphes.indexOf(matchs[0]);
          correctImgList[correctIndex] = this.picResult[i];
          this.imgRow[correctIndex] = this.templateRow[i];
        } else {
          this.clearBindStatus();
          return this.$alert("命名不正确");
        }
      }
      if (correctImgList.filter((img) => img).length < this.imgRow.length) {
        this.clearBindStatus();
        return this.$alert("命名不正确");
      }
      for (let i = 0; i < index; i++) {
        this.$set(this.imgs, i, correctImgList[i]);
      }
      this.picName = this.imgRow[0].name.replace(
        /(?=.*?)(（.*?）)?-[A-Z]\..*$/,
        ""
      );
      this.changeIndex = 0;
    }, 80);
  }

  async submitUpload() {
    let { picName, type, imgs, imgRow } = this;

    if (!picName) {
      return this.$alert("图片命名不可为空");
    }
    if (type === null) {
      return this.$alert("请选择类目");
    }
    if (!imgs.length) {
      return this.$alert("请选择要上传的图片");
    }
    this.isUploading = true;
    let formData = new FormData();
    formData.append("picName", picName);
    let types = this.type.length == 1 ? this.type[0] : this.type[1];
    formData.append("type", types);
    for (let i = 0; i < imgRow.length; i++) {
      formData.append("pics", this.imgRow[i]);
    }
    Axios.postForm(`/api/product/pics/save`, formData).then(
      ({ data: { status, data, msg } }) => {
        if (status === 200) {
          this.$message({
            message: `类目：${data.categoryName}\n图片命名：${data.picName}\n图片编码：${data.picCode}\n添加成功！`,
            showClose: true,
            customClass: "showDialog",
            duration: 0,
          });
          this.picName = null;
          this.imgs = [];
          this.imgRow = [];
        } else {
          this.$message({
            message: msg,
            showClose: true,
            customClass: "showDialog",
            duration: 0,
          });
        }
        this.isUploading = false;
      }
    );
  }
}
